<template>
    <div role="tab"
         id="tab-digital"
         tabindex="10"
         @keydown.enter.prevent="$emit('click')"
         @keydown.space.prevent="$emit('click')"
         :class="{'has-discount': useHasDiscount(discountPrice, discountDateStart, discountDateEnd)}"
    >
        <div>
            <span class="label">
                {{ label }}
            </span>
            <span class="discount"
                  v-if="['CA', 'CH'].indexOf(country) < 0 && useHasDiscount(discountPrice, discountDateStart, discountDateEnd)  && display_price">
                <span>{{ $t('Promo') }}</span>
            </span>
        </div>
        <div v-if="['FR', 'BE'].indexOf(country) >= 0  && display_price">
            <span class="price">
                {{ useFormatPrice(props.price) }} &euro;<sup>*</sup>
            </span>
            <span class="price price--discount"
                  v-if="useHasDiscount(discountPrice, discountDateStart, discountDateEnd)">
                {{ useFormatPrice(props.discountPrice) }} &euro;<sup>*</sup>
            </span>
        </div>
    </div>
</template>
<script setup>
import {useFormatPrice, useHasDiscount} from "../composables.js";
import {computed, inject} from "vue";
import {trans} from "laravel-vue-i18n";

const currentDomain = inject('currentDomain');

const props = defineProps({
    country: [String],
    price: [Number, String],
    format_id: Number,
    display_price: Boolean,
    discountPrice: Number,
    discountDateStart: String,
    discountDateEnd: String,
});

const label = computed(() => {
    if (props.format_id === 34) {
        return trans('Format numérique');
    } else if (currentDomain.value === 'www.didierfle.com') {
        return 'ebook';
    }
    return trans('Livre numérique')
});
</script>
